<template>
  <app-widget 
    :title="$t('common.map.title')"
    :loading="loading">
    <main-map 
      v-if="(markers && markers.length || circles && circles.length)"
      :displayPath="true"
      :markers="markers"
      :mapPositionCoordinates="mapPositionCoordinates"
      slot="widget-content"
      :selected-marker="selectedDevice"
      :circles="circles" />
    <p 
      v-if="!loading && (!circles && !circles.length) && (!markers || !markers.length)"
      class="text-center"
      slot="widget-content">
      {{ $t('common.map.noData') }}
    </p>
  </app-widget>
</template>

<script>
import AppWidget from '@/components/widgets/AppWidget';
import MainMap from '@/components/maps/Main';

export default {
  name: 'DeviceDetailsMap',
  props: {
    markers: Array,
    mapPositionCoordinates: Object,
    onDeviceSelected: Function,
    selectedDevice: Object,
    loading: Boolean,
    circles: Array
  },
  components: {
    AppWidget,
    MainMap
  }
}
</script>